import { Component, OnInit } from '@angular/core';
import { SideMenuService } from 'src/app/_core/services/sidemenu.service';

@Component({
  selector: 'app-sidebar',
  templateUrl: './sidebar.component.html',
  styleUrls: ['./sidebar.component.scss'],
})
export class SidebarComponent implements OnInit {
  ambiente = '';
  menuItems: any[];
  routeActive: string = '';

  constructor(public subMenuService: SideMenuService) {
    this.menuItems = subMenuService.menuItems;
  }

  ngOnInit(): void {}
}
